<template>
  <div>
    <rabbey-toolbox>
      <div class="mr-5">
        <el-select
          v-model="type"
          placeholder="Tipo"
          class="box-item"
          size="mini"
        >
          <el-option value="Cantidad">Cantidad</el-option>
          <el-option value="Monto">Monto</el-option>
        </el-select>
      </div>

      <div class="mr-5">
        <el-select v-model="TypeAgent" @change="handlerChanges" size="mini">
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5">
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </div>
    </rabbey-toolbox>

    <!-- table principal -->
    <el-row>
      <el-col>
        <rabbey-table3
          element-loading-text="Esta consulta puede tardar, por favor esperar."
          :columns="mapColumns"
          :show-summary="true"
          :summary-method="getSummaries"
          :data.sync="items"
          :loading="request.loading"
          @rtable-push-action="HandlerAction"
        />
      </el-col>
    </el-row>

    <!-- table detalle por agentes -->
    <rabbey-base-drawer
      title="Reporte de cobros"
      :drawer.sync="cobros"
      size="80%"
    >
      <el-row>
        <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr style="font-size: 25px">
                <td>Ejecutivo:</td>
                <td>
                  <strong> {{ executive }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Año:</td>
                <td>
                  <strong> {{ year }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Mes:</td>
                <td>
                  <strong> {{ month }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Facturas:</td>
                <td>
                  <strong> {{ Cant }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Total:</td>
                <td>
                  <strong> {{ formatMonto(TotalG) }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <rabbey-toolbox filterables @filter-search="detailSearch = $event" />

      <el-row>
        <el-col>
          <rabbey-table3
            ref="table"
            :search="detailSearch"
            :loading.sync="loadingDetails"
            :actions="actions"
            :columns="columnsDetails"
            :data="registers"
            @rtable-push-action="HandlerAction"
          />
        </el-col>
      </el-row>

      <el-drawer
        title="Cambio de fecha de pago"
        :append-to-body="true"
        :before-close="handleClose"
        :visible.sync="formpayment"
        size="25%"
      >
        <hr />
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <el-form
                  ref="form"
                  label-width="120px"
                  v-model="form"
                  label-position="top"
                >
                  <el-form-item label="Contacto">
                    <el-select
                      v-model="form.contactName"
                      v-loading="loadingContacts"
                      placeholder="Contactos"
                      style="width: 100%"
                      @change="handleContactSelect"
                    >
                      <el-option
                        style="width: 100%"
                        v-for="item in contacts"
                        :key="item.Code"
                        :label="item.FullName"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Teléfono">
                    <el-input
                      placeholder="Teléfono"
                      v-model="form.contactNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Celular">
                    <el-input
                      placeholder="Celular"
                      v-model="form.contactPhoneNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Correo">
                    <el-input
                      placeholder="Correo"
                      v-model="form.contactEmail"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Fecha de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Fecha Original"
                      v-model="form.currentdate"
                      disabled
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Nueva Fecha Promesa de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Nueva Fecha"
                      v-model="form.newdate"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Motivo de Promesa de Pago">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Comentario"
                      v-model="form.comment"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      type="primary"
                      :loading="handleButtonLoading"
                      :disabled="!isValid"
                      size="mini"
                      @click="onSubmit"
                      >Guardar cambios</el-button
                    >
                    <el-button @click="handleClose" size="mini"
                      >Cancelar</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>

      <el-drawer
        title="Comentarios de Interacciones"
        :visible.sync="Dcoments"
        :append-to-body="true"
        :before-close="handleCloseCommentsDrawer"
        size="60%"
      >
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <rabbey-table-3
                  :columns="columnsComments"
                  v-loading="loadingDetails"
                  :before-close="handleClose"
                  :data="comments"
                />
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { GetMonthInLetterBeginingOnZero, formatMonto } from "../../../../utils";
import { MONTHS_LIST } from "@/const";
import yearcomponent from "@/components/Global_System/YearsComponent";
import { PaymentDetails, commentColumns } from "@/helpers/MonthsColumns";
import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";

export default {
  name: "CollectionList",
  components: { yearcomponent },
  computed: {
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    Cant: function () {
      return this.registers.length;
    },
    TotalG: function () {
      if (this.registers.length <= 0) {
        return 0;
      }

      return this.registers
        .filter((item) => item.Amount > 0)
        .map((item) => item.Amount)
        .reduce((a, c) => a + c);
    },

    mapColumns() {
      let columns = this.columns;
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST[i];
        columns.push({
          prop: month,
          label: this.$t(`months.${month}`),
          name: this.$t(`months.${month}`),
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkColumn
        });
      }

      columns.push({
        prop: "Totals",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          OpenSelection: this.OpenSelection,
          getType: this.getType,
          month: 0
        },
        formatter: HyperLinkColumn
      });
      return columns;
    }
  },
  data() {
    return {
      detailSearch: "",
      principalTable: false,
      loadingDetails: false,
      cobros: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "accountingmanager",
      type: "Cantidad",
      executive: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      AccountNumber: "",
      Amount: 0,
      InvoiceNum: "",
      ContactEmail: "",
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactName: "",
        contactData: "",
        contactEmail: "",
        contactNumber: "",
        contactPhoneNumber: ""
      },
      types: [
        { value: "vendor", label: "Vendedor" },
        { value: "customerservice", label: "Servicio al Cliente" },
        { value: "accountingmanager", label: "Cuenta por Cobrar" }
      ],
      columns: [
        {
          prop: "ExecutiveName",
          label: "Ejecutivo",
          minWidth: 220,
          fixed: true
        }
      ],
      columnsDetails: [...PaymentDetails],
      columnsComments: [...commentColumns],
      actions: [
        {
          icon: "el-icon-date",
          label: "Cambiar fecha de pago",
          command: "change-date-payment"
        },
        {
          icon: "el-icon-chat-line-square",
          label: "Ver comentario",
          command: "see-comments"
        }
      ],
      items: [],
      registers: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      request: null, // Seguimiento de solicitud, para su cancelacion.
      handleButtonLoading: false,
      selectedRow: {}
    };
  },
  created() {
    this.principalTable = true;
    this.getData();
  },
  methods: {
    formatMonto,
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Totales";
          return;
        }

        let col = column.property;
        if (this.type === "Monto") {
          col = `${column.property}Amount`;
        }

        const values = data.map((item) => Number(item[col]));
        if (!values.every((value) => isNaN(value))) {
          let val = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          if (this.type === "Monto") {
            val = this.formatMonto(val);
          }

          sums[index] = val;
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    OpenSelection(mes, vendor, name) {
      mes = mes - 1;
      this.month = GetMonthInLetterBeginingOnZero(mes);
      mes = mes + 1;
      this.cobros = true;
      this.executive = name;
      this.getDetailsinfo(vendor, mes, this.year);
    },
    getType() {
      return this.type;
    },
    onSubmit() {
      this.handleButtonLoading = true;
      var data = {
        OldDate: this.form.currentdate,
        PromiseDate: this.form.newdate,
        CustomerCode: this.AccountNumber,
        Amount: this.Amount,
        Motive: this.form.comment,
        CompanyID: this.currentCompany,
        User: this.currentUser.FullName,
        InvoiceNum: this.invoiceNum,
        ContactName: this.form.contactData.FullName,
        ContactEmail: this.form.contactData.Email,
        ContactNumber: this.form.contactData.PhoneNumber,
        ContactCode: this.form.contactData.Code,
        SalesPersonCode: this.currentUser.PersonCode,
        CustomerServiceExec_: this.currentUser.CustomerServiceExec_,
        UserID: this.currentUser.UserID
      };
      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleButtonLoading = false;
          this.getDetailsinfo(
            this.selectedRow.VendorCode,
            new Date(this.selectedRow.PostingDate).getMonth() + 1,
            this.year
          );
          this.handleClose();
        });
    },
    handler_year(_year) {
      this.principalTable = true;
      this.year = _year;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactName = "";
      this.form.contactEmail = "";
      this.form.contactNumber = "";
      this.form.contactPhoneNumber = "";
      this.AccountNumber = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
      this.formpayment = false;
      this.selectedRow = {};
    },
    handleCloseCommentsDrawer() {
      this.Dcoments = false;
      this.comments = [];
    },
    HandlerAction(action) {
      const { command } = action;
      const { CustomerNo, PostingDate, DocumentNo } = action.row;

      this.Amount = action.row.Amount;
      this.AccountNumber = CustomerNo;
      this.invoiceNum = DocumentNo;
      this.OldDate = PostingDate;

      switch (command) {
        case "change-date-payment":
          this.formpayment = true;
          this.selectedRow = action.row;
          this.form.currentdate = PostingDate;
          this.getContactsByCustomerCode(CustomerNo);
          break;
        case "see-comments":
          this.Dcoments = true;
          this.getcomments(CustomerNo);
          break;
        default:
          break;
      }
    },

    getcomments(customerCode) {
      let parameters = {
        CustomerCode: customerCode,
        CompanyId: this.currentCompany
      };
      this.commentloading = true;
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", {
          params: parameters
        })
        .then((response) => {
          response.data.Items.forEach((row) => {
            if (row.Description) {
              const cleanComment = row.Description.replace(/(<([^>]+)>)/gi, "");
              row.Description = cleanComment;
            }
          });
          this.prospectDetailInteractions = response.data.Items;
          this.comments = response.data.Items;
        })
        .finally(() => {
          this.commentloading = false;
        });
    },
    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    handlerChanges() {
      this.principalTable = true;
      this.getData();
    },
    getDetailsinfo(code, month = Number, year = Number) {
      this.loadingDetails = true;
      this.$http
        .get(`/api/accountsReceivable/PeddingPaymentDetails`, {
          params: {
            ExecutiveCode: code,
            month: month,
            year: year,
            CompanyId: this.currentCompany,
            typeAgent: this.TypeAgent
          }
        })
        .then(({ data }) => {
          data.forEach((interaction) => {
            if (interaction.LatestComment) {
              var str = interaction.LatestComment.replace(/(<([^>]+)>)/gi, "");
              interaction.LatestComment = str;
            }
          });
          this.registers = data;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    getData() {
      this.principalTable = true;

      const axiosSource = axios.CancelToken.source();
      if (this.request) {
        this.request.cancel();
        this.request = null;
      }

      this.request = {
        cancel: axiosSource.cancel,
        msg: "Loading...",
        loading: true
      };

      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany
      };

      this.$http
        .get("/api/accountsReceivable/paymentmaster", {
          cancelToken: axiosSource.token,
          timeout: 3000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;

          this.request.loading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.principalTable = false;
        });
    },
    handleContactSelect(contact) {
      this.form.contactData = contact;
      this.form.contactName = contact.FullName;
      this.form.contactEmail = contact.Email;
      this.form.contactNumber = contact.MobilePhoneNumber;
      this.form.contactPhoneNumber = contact.PhoneNumber;
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
